import React from 'react'
import styles from './school-import.styles'
import injectSheet from 'react-jss'
import Section from '../../../../shared/section/section'
import StatusConnected from './status/status-connected/status-connected.container'
import StatusNotConnected from './status/status-not-connected/status-not-connected.container'
import StatusPulling from './status/status-pulling/status-pulling.container'
import StatusFinished from './status/status-finished/status-finished.container'
import StatusNotInWonde from './status/status-not-in-wonde/status-not-in-wonde.container'

const SchoolImport = ({
  classes,
  title,
  pending,
  id,
  connected,
  notConnected,
  pulling,
  finished,
  notInWonde,
  usingGroupCall
}) => (
  <Section
    className={classes.section}
    pending={pending}
    title="Import from MIS">
    <div className={classes.container}>
      <h4 className={classes.title}>{title}</h4>
      <div className={classes.status}>
        {connected && <StatusConnected />}
        {!usingGroupCall && (
          <div>
            {notConnected && <StatusNotConnected />}
            {pulling && <StatusPulling />}
            {finished && <StatusFinished />}
            {notInWonde && <StatusNotInWonde />}
          </div>
        )}
        {usingGroupCall && <StatusFinished />}
      </div>
    </div>
  </Section>
)

export default injectSheet(styles)(SchoolImport)
